import React from "react";
import { Routes, Route } from "react-router-dom";
import Home from "./pages/home/Home";
import AboutUs from "./pages/about/AboutUs";
import Events from "./pages/Events";
import Ministry from "./pages/Ministry";
import MembershipForm from "./pages/MembershipForm";
import FellowshipPage from "./pages/FellowshipPage";
import Sermons from "./pages/Sermons";
import NotFound from "./pages/NotFound";

export default function WebsiteRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/about-us" element={<AboutUs />} />
      <Route path="/sermons" element={<Sermons />} /> 
      <Route path="/events" element={<Events />} />
      <Route path="/ministry" element={<Ministry />} />
      <Route path="/membership" element={<MembershipForm />} />
      <Route path="/fellowship" element={<FellowshipPage />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}